import { GLOBAL_AGENTS_SID } from "@app/types/assistant/assistant";
import type { PodFrameTab } from "@app/types/pod_frame_tab";

export interface PodMetadataType {
  sId: string;
  createdAt: number;
  updatedAt: number;
  spaceId: string;
  description: string | null;
  archivedAt: number | null;
  todoGenerationEnabled: boolean;
  lastTodoAnalysisAt: number | null;
  pinnedFramePath: string | null;
  frameTabs: PodFrameTab[];
  /** System tab ids + frame paths before Settings. */
  tabsOrder: string[];
  defaultAgentId: string | null;
  defaultSkillIds: string[];
  isAdminControlled: boolean;
  /** The Project agent answers untagged messages in this Project's conversations. */
  podAgentEnabled: boolean;
}

/**
 * The agent a new conversation in this Project opens with. A Project running its own
 * agent opens with it, so the composer names the same agent the untagged-message
 * rule would pick server-side (`lib/api/projects/default_agent.ts`).
 */
export function podEffectiveDefaultAgentId(
  metadata: PodMetadataType | null | undefined
): string | null | undefined {
  return metadata?.podAgentEnabled
    ? GLOBAL_AGENTS_SID.POD
    : metadata?.defaultAgentId;
}
